module.exports = __webpack_public_path__ + "static/media/linkedin.c336924d.svg";